import React from 'react'
import { base_url } from '../Api/Api';

const NotificationConfig = () => {

    console.log('NotificationConfig')
    window.najvaUserSubscribed = function (najva_user_token) {
        console.log('localStorage.getItem(api_key)',JSON.parse(localStorage.getItem('api_key')))
        if (localStorage.getItem('api_key') != null) {
            const Data = {
                'webpush_id': najva_user_token
            };
            const headers = {
                'Authorization': JSON.parse(localStorage.getItem('api_key')),
                'content-type': 'application/json'
            };
            base_url.post('pwa_pushid', Data, {
                headers: headers
            })
                .then((response) => {
                    console.log(response)
                })
                .catch((error) => {
                    console.log(error.response);
                });

        } else {
            localStorage.setItem('gcm_id', najva_user_token)
        }
    }
}

export default NotificationConfig;